import React from "react";
import { useT } from "./i18n/context";

export function Manifesto() {
  const { home } = useT();
  return (
    <section className="py-24 px-6">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight mb-5" style={{ color: "var(--text-primary)" }}>
          {home.manifesto.title}
        </h2>
        <p className="text-base sm:text-lg leading-relaxed" style={{ color: "var(--text-secondary)" }}>
          {home.manifesto.body}
        </p>
      </div>
    </section>
  );
}

export default Manifesto;
